<template>
	<div class="mini_favourite_button">
		<span v-on:click.prevent="removeFromFavourites()" v-if="in_favourites==true">
			<i class="fas fa-heart"></i> Remove from Wishlist
		</span>
		<span v-else v-on:click.prevent="addToFavourites()">
			<i class="fal fa-heart" v-on:click.prevent="addToFavourites()"></i> Add to Wishlist
		</span>
	</div>
</template>
<script>
import { mapActions } from "vuex";
export default {

	props: [
		'product'
	],

	data: () => {
		return {
			in_favourites: false,
		}
	},

	created() {
		this.in_favourites = this.product.in_favourites;
	},

	methods: {
		...mapActions(["addAlert"]),

		addToFavourites: function(){
			axios.post('/box/wishlist/add', {
				Model_Type: '\\App\\Product',
				Model_Id: this.product.id,
				Quantity: 1,
				FreeTypeAttributes: ''

			}).then((response) => {
				this.in_favourites = true;
				this.addAlert({
					alertClass: 'alert-success', 
					alertMessage: '<strong>Success!</strong> ' + this.product.name + ' added to wishlist. <a href="/account/wishlist" class="btn">View Wishlist</a>', 
					alertImportant: false,
				})
			});
		},

		removeFromFavourites: function(){
			axios.post('/box/wishlist/removeModel', {
				Model_Type: '\\App\\Product',
				Model_Id: this.product.id,
			}).then((response) => {
				this.in_favourites = false;
				this.addAlert({
					alertClass: 'alert-success', 
					alertMessage: '<strong>Success!</strong> ' + this.product.name + ' removed from wishlist', 
					alertImportant: false,
				})
			});
		}

	}

};
</script>